module.exports = __webpack_public_path__ + "images/6b651fd7.exclusive_1_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/exclusive/exclusive_1_cht.png
// module id = 525
// module chunks = 0